import { Box, Center, Spinner } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import useInternationalCompanyGroup from './useInternationalCompanyGroup';
import Toolbar from './Toolbar';
import Modal from './Modal';
import AlertPopup from './AlertPopup';
import { FC } from 'react';

const InternationalCompanyGroupTab: FC<{ readonly: boolean }> = ({ readonly }) => {
    const {
        isRetailersLoading,
        isLoading,
        table,
        handleOpenModal,
        modalType,
        isModalOpen,
        setIsModalOpen,
        globalCompanyId,
        modalData,
        setModalData,
        emptyModalData,
        internationalCompanies,
        updateModalData,
        isInternationalCompaniesLoading,
        isDeleteOpen,
        onDeleteOpen,
        onDeleteClose,
    } = useInternationalCompanyGroup();

    return (
        <Box mt="16px">
            <Toolbar
                {...{
                    table,
                    isLoading,
                    isRetailersLoading,
                    handleOpenModal,
                    setModalData,
                    emptyModalData,
                    isInternationalCompaniesLoading,
                    internationalCompanies,
                    readonly,
                }}
            />
            {isLoading || isRetailersLoading ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable table={table} isPagination isHeaderFixed />
                    <TablePagination table={table} />
                    <Modal
                        {...{
                            updateModalData,
                            isModalOpen,
                            setIsModalOpen,
                            internationalCompanies,
                            modalType,
                            modalData,
                            isLoading,
                            setModalData,
                            globalCompanyId,
                            onDeleteOpen,
                            readonly,
                        }}
                    />
                    <AlertPopup
                        isDeleteOpen={isDeleteOpen}
                        onDeleteOpen={onDeleteOpen}
                        onDeleteClose={onDeleteClose}
                        modalData={modalData}
                    />
                </>
            )}
        </Box>
    );
};

export default InternationalCompanyGroupTab;
